/**
 * 用户展示名解析 —— 全站唯一的优先级链：
 *   有效昵称 → 用户名（如 aaa789456）→ 派生昵称（兜底）→ #短ID
 *
 * 「派生昵称」= 登录链路自动填充的机器形态（纯数字学号/手机号、含 @、
 * 超长 UUID），对人不友好；仅在既没有昵称也没有用户名时才显示它。
 */
export function looksDerivedName(n: string | null | undefined): boolean {
  return !n || /^\d+$/.test(n) || n.includes('@') || n.length > 20;
}

export function displayName(u: {
  display_name?: string | null;
  username?: string | null;
  user_id?: string;
}): string {
  const dn = u.display_name?.trim();
  if (dn && !looksDerivedName(dn)) return dn;
  const un = u.username?.trim();
  if (un) {
    if (un.includes('@')) {
      // 南哪链路会把校园邮箱存进 username；展示只取本地部分——
      // 域名绝不能出现在界面上（品牌红线：不出现校名）
      const local = un.slice(0, un.indexOf('@')).trim();
      if (local) return local;
    } else {
      return un;
    }
  }
  if (dn) return dn;
  return u.user_id ? `#${u.user_id.slice(0, 8)}` : '?';
}

/** 当前展示名会落到「机器形态」（学号/邮箱/手机号/#ID）时才值得引导设置昵称。 */
export function needsNicknameHint(u: {
  display_name?: string | null;
  username?: string | null;
}): boolean {
  return looksDerivedName(u.display_name) && looksDerivedName(u.username);
}
